import * as React from 'react'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { VehicleEventModel } from '@/app/models/vehicleEventModel'
import {
  translateTachographEventType,
  getTachographEventCode,
} from '@/modules/drivers/helpers/tachographEventTypeResolver'
import { TableHeaderColumn } from '@/modules/drivers/types/table'
import { ViolationsListHeader } from './ViolationsListHeader'
import ViolationsListRowItem from './ViolationsListRowItem'
import { formatDateTime } from '@/app/common/dateHelper'

const TachographEventsList = ({
  events,
}: {
  events?: ReadonlyArray<VehicleEventModel>
}) => {
  const { t } = useLocalize()

  if (!events || events.length === 0) return null

  const columns: TableHeaderColumn[] = [
    { title: 'LP', key: null, type: 'string', sort: false },
    { title: t('driverModule.event-code'), key: null, type: 'string', sort: false },
    { title: t('importModule.fi-fault-type'), key: null, type: 'string', sort: false },
    { title: t('common.from'), key: null, type: 'string', sort: false },
    { title: t('common.to'), key: null, type: 'string', sort: false },
    { title: t('driverModule.registration-number'), key: null, type: 'string', sort: false },
  ]

  return (
    <section className="tw-h-fit tw-overflow-x-auto">
      <div className="tw-relative tw-h-full">
        <div className="tw-flex tw-items-center tw-gap-2 tw-px-2 tw-pt-2 tw-text-sm tw-font-semibold tw-text-content-base">
          <span>⚠</span>
          <span>{t('driverModule.tachograph-events')}</span>
        </div>
        <table className="tw-relative tw-w-full tw-table-auto tw-border-spacing-x-2 tw-pl-2">
          <ViolationsListHeader columns={columns} />
          <tbody>
            {events.map((event, index) => (
              <tr
                key={index}
                className={`notches-border--right tw-w-fit tw-cursor-pointer tw-border-b tw-bg-white hover:tw-bg-primary/10`}
              >
                <ViolationsListRowItem size="small" bolder={false}>
                  {index + 1}
                </ViolationsListRowItem>
                <ViolationsListRowItem size="small" bolder={false}>
                  {getTachographEventCode(event.type)}
                </ViolationsListRowItem>
                <ViolationsListRowItem size="small" bolder={false}>
                  {translateTachographEventType(event.type, t)}
                </ViolationsListRowItem>
                <ViolationsListRowItem size="small" bolder={false}>
                  {formatDateTime(event.beginTime)}
                </ViolationsListRowItem>
                <ViolationsListRowItem size="small" bolder={false}>
                  {formatDateTime(event.endTime)}
                </ViolationsListRowItem>
                <ViolationsListRowItem size="small" bolder={false}>
                  {event.registrationNumber || '-'}
                </ViolationsListRowItem>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  )
}

export default TachographEventsList
